<template>
  <div class="edu-courses-area banner07 ptb-100">
    <div class="container">
      <div class="edu-section-title">
        <h4 class="mb-4">
          9 - 14 December 2024 <br /><span class="text-primary"
            >Ibis Styles Jakarta Sunter</span
          >
        </h4>
        <h2>Get Special Price <br />For All In Package</h2>
      </div>
      <div class="row justify-content-center">
        <div
          class="col-lg-6 col-md-6 col-sm-12"
          v-for="(item, index) in listProduct"
          :key="index"
        >
          <router-link to="/register" class="single-courses-link">
            <div class="single-courses-box02">
              <div class="image">
                <img :src="item.product_image" alt="image" />
              </div>
              <div class="content">
                <div v-if="item.id == 47">
                  <div class="discount">
                    <div class="text-strokes">USD 2700</div>
                    <div class="discount-tag-wrapper">
                      <span class="discount-tag-icon"
                        ><svg
                          width="21"
                          height="39"
                          viewBox="0 0 21 39"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M18.0808 0C16.5161 0 15.0277 0.67567 13.9977 1.8535L1.34101 16.3268C-0.480869 18.4102 -0.442043 21.5311 1.4311 23.5685L14.0068 37.247C15.034 38.3642 16.4822 39 17.9998 39H20.2725V0L18.0808 0ZM11.361 23.4843C13.5614 23.2888 15.1868 21.3465 14.9912 19.146C14.7957 16.9455 12.8534 15.3202 10.6529 15.5157C8.45245 15.7113 6.82711 17.6536 7.02263 19.8541C7.21815 22.0545 9.16049 23.6799 11.361 23.4843Z"
                            fill="#fc5185"
                          ></path></svg></span
                      ><span class="discount-tag-body">40% OFF</span>
                    </div>
                  </div>
                </div>
                <div class="content-herd">
                  <span class="cr-price"
                    >{{ item.currency_type.code }} {{ item.price }}</span
                  >
                </div>
                <h3>{{ item.name }}</h3>
              </div>
            </div>
          </router-link>
        </div>
        <div class="section-button">
          <router-link to="/register" class="btn btn-lg btn-primary"
            >Register Now</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import { ref } from "vue";

const listProduct = ref([]);
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

const loadProduct = async () => {
  axios({
    method: "get",
    url: apiBaseUrl + "product/list/public?is_pagination=true&page=1&limit=10",
  })
    .then((response) => {
      listProduct.value = response.data.data;
    })
    .catch((error) => {
      console.log(error.message);
    });
};

loadProduct();
</script>

<style>
.discount {
  display: flex;
  align-items: end;
  margin-bottom: 20px;
}
.text-strokes {
  text-decoration: line-through;
  font-weight: 400;
  font-size: 1.5rem;
  margin-right: 15px;
}
.discount-tag-icon {
  display: flex;
}
.discount-tag-body {
  align-items: center;
  background-color: #fc5185;
  border-radius: 0 5px 5px 0;
  display: flex;
  height: 39px;
  margin-left: -2px;
  padding: 10px 20px 10px 8px;
  white-space: nowrap;
}
.discount-tag-wrapper {
  align-items: center;
  color: #fff;
  display: flex;
  justify-content: center;
  transform: rotate(-6deg);
}
.normal-price {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-discount {
  font-size: 5rem;
  font-weight: 600;
}
</style>
